import {
  DEFAULT_VARIATION_OPTIONS_BY_TYPE,
  EVariationTypes,
} from 'core/common/constants/multivariation'
import { IVariation } from 'core/components/Variations/types'
import { IOptionProps } from 'core/components/VariationsAutocompleteField/types'

export const getVariationByTypeAndValue = (type: EVariationTypes, value: string): IOptionProps => {
  const item = DEFAULT_VARIATION_OPTIONS_BY_TYPE[type].find(({ title }) => title === value)

  return {
    title: item?.title || value,
    color: item?.color,
  }
}

export const mapVariationValueToLabel = (
  type: EVariationTypes,
  variation: IOptionProps
): IVariation => ({
  label: variation.title,
  color: variation.color,
  showAvatar: type === EVariationTypes.COLOR,
})
